/*
 *
 * Copyright (c) Vaisala Oyj. All rights reserved.
 *
 */

import { ThemeMode , Button, Form, Heading, Modal, RadioButton } from '@vaisala/rockhopper-components';

import { useChangeLanguage } from '../i18n/useChangeLanguage';
import { useTheme } from '../state/theme';
import { useTranslation } from 'react-i18next';

const { Dark, Light } = ThemeMode ;

export const SettingsModal = ({ visible, onDismiss }: { visible: boolean; onDismiss: VoidFunction }) => {
  const { t } = useTranslation();
  const change = useChangeLanguage();
  const { setTheme, theme: currentTheme } = useTheme();

  return (
    <Modal onDismiss={onDismiss} isOpen={visible} showCloseIcon>
      <Heading level={2} className="vai-margin-top-none">
        {t('settings.title')}
      </Heading>
      <Form.Item label={t('settings.language')}>
        {['en', 'fi'].map((lang) => (
          <RadioButton disabled key={lang} checked={lang === change.current} value={lang} onChange={() => (change as any)[lang]()}>
            {/* Enable if translation is enabled */}
            {t(`language.${lang}`)}
          </RadioButton>
        ))}
      </Form.Item>
      <Form.Item label={t('settings.theme')}>
        {[Light, Dark].map((theme) => (
          <RadioButton key={theme} checked={theme === currentTheme} value={theme} onChange={() => setTheme(theme)}>
            {t(`theme.${theme.split('-')[2]}`)}
          </RadioButton>
        ))}
      </Form.Item>
      <Button onClick={onDismiss}>{t('settings.modal_close_btn')}</Button>
    </Modal>
  );
};
